module.exports = __webpack_public_path__ + "static/media/illustrations.094b669c.svg";